module.exports = {"id":"191164","name":"Fidel Martínez","rating":"72","photo":"./data/images/photos/1/191164.png","club":{"name":"Agents libres","logo":"./data/images/clubs/Agentslibres.png"},"positions":["BU","MG"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/FidelMartinez0.json
// module id = 1431
// module chunks = 0